<template>
  <div class="test-details-top">

    <div class="item">
      <!-- :label="$mal.get('tests.soil.name')" -->
      <app-text-input
        :label="$ml.get(`Name`)"
        v-model="form.name"
      />
    </div>


    <div class="item">
      <date-selector :not-after="true" v-model="form.date" :label="$ml.get(`Sampling Date`)"/>
    </div>

    <div class="item" v-if="form.isExtensions">
      <app-sel
        key-name="id"
        label-name="name"
        :label="$ml.get(`Soil lab / methods`)"
        :items="labs"
        v-model="form.methodId"
        :readonly="true"
        @input="onLabSelect"
        :disabled="true"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            :value="items[0]"
            :key="items[0].id"
          >
            {{ $ml.get(items[0].name) }}
          </app-sel-opt>
        </template>
      </app-sel>
    </div>

    <!-- <div class="item">
      <app-sel
        key-name="id"
        label-name="name"
        :label="$ml.get(`Soil texture`)"
        :items="textures"
        v-model="form.textureId"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            v-for="item in items"
            :value="item"
            :key="item.id"
          >
            {{ $ml.get(item.name) }}
          </app-sel-opt>
        </template>
      </app-sel>
    </div> -->
    <div class="item">
      <app-sel
        key-name="id"
        label-name="name"
        v-model="form.farmId"
        :items="$store.getters['farms/farms']"
        :label="$ml.get(`Farm`)"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            v-for="item in items"
            :value="item"
          >
            {{ item.name }}
          </app-sel-opt>
        </template>
      </app-sel>
    </div>


    <div class="item">
      <app-sel
        key-name="id"
        label-name="name"
        :label="$ml.get(`Field`)"
        :items="fields"
        :disabled="!form.farmId"
        v-model="form.fieldId"
      >
        <template v-slot="{ items }">
          <app-sel-opt
            v-for="field in items"
            :value="field"
            :key="field.id"
          >
            {{ field.name }}
          </app-sel-opt>
        </template>
      </app-sel>
    </div>

     <div class="item">
      <app-text-input
        label="pH"
        v-model="form.ph"
        type="number"
        min="0"
        max="14"
      />
    </div>

    <div class="item">
      <app-checkbox :label="$ml.get(`I have extraction methods`)" v-model="form.isExtensions" />
    </div>

  </div>
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      selectedLab: ''
    }
  },
  created () {
    // console.log(this.labs);
    // var test = this.labs.find(item => item.name == 'Default');
    // console.log(test);
  },
  methods: {
    onLabSelect(lab) {
      this.$store.dispatch('tests/media/onLabSelect', lab);
      this.selectedLab = lab;
    },
  },
  computed: {
    ...mapGetters({
      form: 'tests/media/form',
      labs: 'tests/media/labs',
    }),
    fields() {
      const farm = this.$store.getters['farms/getFarmById'](this.form.farmId);
      return farm ? farm.fields : null
    }
  },
  watch: {
    'form.isExtensions': async function (val) {
      if (!val) {
        let lab

        !this.selectedLab ? lab = this.labs[0] : this.labs.find(n => n.id == this.selectedLab);

        if(!lab) return;
        this.form.methodId = lab.id;
        await this.$store.dispatch('tests/media/onLabSelect', lab.id);
      }
    }
  }
}
</script>

<style lang="scss" scoped>

.test-details-top {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;

  .item {
    width: 50%;
    margin-top: 30px;
    padding: 0 10px;

    display: flex;
    align-items: center;
    justify-content: center;

    > * {
      width: 100%;
    }
    &:last-child {
      width: fit-content;
      width: -moz-fit-content;
      width: -webkit-fit-content;
      margin-right: 50%;
    }
  }
}

</style>
